import _ from 'lodash';
import interceptor from 'rest/interceptor';

const SuccessCodesInterceptor = interceptor({
  init: config => config,
  response: (response, config) => {
    if (response.status && !_.includes(config.successCodes, response.status.code)) {
      return Promise.reject(response);
    }
    return response;
  }
});

export default SuccessCodesInterceptor;



/** WEBPACK FOOTER **
 ** ./src/rest/SuccessCodesInterceptor.js
 **/